'use strict';

angular.module(ApplicationConfiguration.applicationModuleName).controller('customerUploadCtrl', function ($scope, $rootScope, $window, $state, $http, $filter, $localStorage, $ngConfirm, permissionService, apiSettings, MessageService, tools, model, Customer, maxAllowedFileSize) {
	var vm = this;

	vm.permissions = permissionService;
	if (!vm.permissions.isAdminAccessAuthorized())
		return;

	var $translate = $filter('translate');

	angular.extend($scope.$parent.vm, {
		title: 'customers.settings.title',
		insertUrl: null
	});

	// INICIALIZAÇÕES
	vm.model = model;
	vm.errors = [];

	// CONFIGURAÇÃO DO UPLOAD
	vm.tempFolder = tools.getRandomString(8);
	vm.uploadConfig = {
		singleFile: true,
		testChunks: false,
		target: apiSettings.baseUri + 'v1/internal/upload' + '?tempFolder=' + vm.tempFolder,
		headers: {
			'Authorization': 'Bearer ' + $localStorage.authorizationData.token
		}
	};

	vm.allowedFileExtensions = ['xlsx'];
	vm.maxAllowedFileSize = parseInt(maxAllowedFileSize.value);

	//UPLOAD
	vm.getallowedFileExtensions = function () {
		return "." + vm.allowedFileExtensions.join(', .');
	};

	vm.getallowedFileExtensionsLabel = function () {
		return "Apenas arquivos do tipo " + vm.getallowedFileExtensions();
	};

	vm.hasErrors = function () {
		return vm.errors && vm.errors.length > 0;
	};

	vm.uploadSubmit = function ($files, $event, $flow) {
		if ($files[0] === undefined)
			return;

		// Valida se a extensão do arquivo é permitida
		if (tools.validateFileExtension($files[0].name, vm.allowedFileExtensions) == false)
			return;

		// Valida o tamanho do arquivo
		if (tools.validateFileMaxSize($files[0].size, vm.maxAllowedFileSize) == false)
			return;

		$flow.upload();
	};

	vm.uploadSuccess = function ($file, $message, $flow) {
		var uploadResult = JSON.parse($message);
		vm.model.name = uploadResult.originalFilename;
		vm.model.fileDocument = uploadResult.filename;
		vm.model.url = tools.getFileTempPath(vm.tempFolder, uploadResult.filename);

		// Reseta o flow
		$flow.cancel();
	};

	vm.uploadError = function ($file, $message, $flow) {
		MessageService.alertError($message);
	};

	vm.resetForm = function () {
		vm.model = {};

		var form = $scope.customerUploadForm;
		form.$setPristine();
		form.$setUntouched();		
	};

	$rootScope.laddaLoading = false;

	vm.import = function () {
		$rootScope.laddaLoading = true;

		vm.errors = [];
		vm.model.tempFolder = vm.tempFolder;		

		Customer.import(vm.model, function (response) {
			if (response.result == false)
			{
				vm.errors = response.errors;
				vm.resetForm();

				MessageService.alertError(response.message);
			}
			else
			{
				MessageService.alertInfo("A importação do arquivo foi concluída com sucesso", null, function () {
					$state.go('main.customer');
				});				
			}
						
		}, function (response) {
			MessageService.alertError(response.data);
		});		
	}
});